export const ASSET_RESOLUTION_OPTIONS = [
  { value: "hdpi", label: "hdpi" },
  { value: "mdpi", label: "mdpi" },
  { value: "tablet", label: "tablet" },
  { value: "xhdpi", label: "xhdpi" },
  { value: "xxhdpi", label: "xxhdpi" },
  { value: "xxxhdpi", label: "xxxhdpi" },
];

export const formControlSx = {
  width: "100%",
  maxWidth: { xs: "100%", md: 360 },
};

export const fileInputStyle = {
  width: "100%",
  boxSizing: "border-box",
  padding: 8,
  border: "1px solid rgba(0,0,0,0.42)",
  borderRadius: 4,
};

const VIDEO_PATH = /\.(webm|mp4|ogg|mov|m4v)(\?|#|$)/i;
const IMAGE_PATH = /\.(gif|png|jpe?g|webp|svg|bmp|ico|avif)(\?|#|$)/i;

export const getAssetPreviewKind = (url) => {
  if (!url?.trim()) return null;

  let pathname = url;
  try {
    pathname = new URL(url, window.location.origin).pathname;
  } catch {
    pathname = url;
  }

  if (VIDEO_PATH.test(pathname)) return "video";
  if (IMAGE_PATH.test(pathname)) return "image";
  return "unknown";
};

export const getMediaKindFromContentType = (contentType) => {
  const ct = String(contentType || "").toLowerCase().split(";")[0].trim();
  if (!ct) return null;
  if (ct.startsWith("video/")) return "video";
  if (ct.startsWith("image/")) return "image";
  return null;
};

export const resolveAssetPreviewKind = (url, contentType = "") => {
  const fromMime = getMediaKindFromContentType(contentType);
  if (fromMime) return fromMime;

  const fromUrl = getAssetPreviewKind(url);
  if (fromUrl && fromUrl !== "unknown") return fromUrl;

  return "unknown";
};

export const getAssetPreviewModesForKind = (kind) => {
  if (kind === "video") return ["video", "open"];
  if (kind === "image") return ["image", "open"];
  return ["video", "open"];
};

export const assetPreviewMediaSx = {
  display: "block",
  width: "100%",
  maxHeight: 360,
  bgcolor: "grey.100",
  borderRadius: 1,
};
